import axios from 'axios';
import { api_labelflow, api_labelflow_training } from "../../../../../config.jsx";


export const handleGetOneAPI = (params) =>
  axios.get(`${api_labelflow}/classification_management/get_one_classification_model_info_by_version_id`, {
    params: params
  });

export const handleSaveClassificationDataAPI = (params) =>
  axios.post(`${api_labelflow}/classification_management/save_classification_data`,
    params, { headers: { "Content-Type": "multipart/form-data" } });

export const handleDownloadClassificationDataAPI = async (params) => {
  try {
    const response = await axios.post(
      `${api_labelflow_training}/export_management/classification_data_download`,
      new URLSearchParams(params), // Send params as form data
      {
        responseType: 'blob', // Expect binary response
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error downloading classification data:', error);
    throw error;
  }
};

export const startClassificationTrainingAPI = async (data) => {
  try {
    const response = await axios.post(
      `${api_labelflow_training}/training_management/cls/start`,
      new URLSearchParams(data),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error starting classification training:', error);
    throw error;
  }
};

export const saveClassificationTrainingConfigAPI = async (data) => {
  try {
    const response = await axios.post(
      `${api_labelflow_training}/training_management/save_training_config`,
      new URLSearchParams(data),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error saving classification training config:', error);
    throw error;
  }
};


/**
 * AI grouping — `POST /cluster/auto` on the training API.
 *
 * ResNet18 embeddings -> KMeans. The endpoint already existed; until now only
 * the assistant could reach it, so the classification studio had no AI at all
 * while the detection studio next door had a whole auto-label panel.
 *
 * NOTE the envelope: this is a TRAINING-api route, so the payload sits one
 * level deeper than every management-api call above — `data.data`. Reading
 * `data.assignments` returns undefined with no error anywhere, which lands
 * every image in one group.
 */
export const autoGroupAPI = async ({ files, numClusters, maxClusters, signal, onProgress }) => {
  const form = new FormData();
  files.forEach((entry) => form.append('images', entry.blob, entry.name || 'image.jpg'));
  if (numClusters) form.append('num_clusters', String(numClusters));
  if (maxClusters) form.append('max_clusters', String(maxClusters));

  const response = await axios.post(`${api_labelflow_training}/cluster/auto`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    signal,
    timeout: 300000,
    onUploadProgress: onProgress
      ? (event) => {
          if (!event.total) return;
          onProgress(Math.min(100, Math.round((event.loaded / event.total) * 100)));
        }
      : undefined,
  });

  const body = response?.data || {};
  if (!body.success || !body.data || !Array.isArray(body.data.assignments)) {
    throw new Error(body.message || 'Grouping the images failed.');
  }
  return body.data;
};
